exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ErrorPage-c2ae8cc0{padding:40px 60px}.icon-d36a839e{color:#757575;height:80px;width:80px;border:2px solid #C8E6DC;border-radius:100%;display:flex;align-items:center;justify-content:center;margin-bottom:20px}\n", ""]);

// Exports
exports.locals = {
	"ErrorPage": "ErrorPage-c2ae8cc0",
	"icon": "icon-d36a839e"
};